import React from 'react';
import { node } from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { SlideTransition } from '../animation';

const SlideSecondary = ({ children }) => (
  <TransitionGroup className="content" style={{ marginTop: '0px' }}>
    {React.Children.map(children, (child, idx) => (
      child && (
        <SlideTransition key={idx}>
          {child}
        </SlideTransition>
      )
    ))}
  </TransitionGroup>
);


SlideSecondary.propTypes = {
  children: node.isRequired,
};

export default SlideSecondary;
